module.exports = __webpack_public_path__ + "img/border_bg_img@3x.8afb6178.png";